// extracted by mini-css-extract-plugin
export default {"tabs-container":"Tabs_tabs-container__BmrDq","tab":"Tabs_tab__X52T4","tab--active":"Tabs_tab--active__2GeJm"};